import { Sport } from "@sportactics/board-editing";
import { Team } from "@sportactics/player-management";
import { createContext } from "react";

import { LazyValue, useLazyContext } from "~utils";

export function useCustomPlayersLocalPersistence(): useCustomPlayersLocalPersistenceReturn {
  return useLazyContext(CustomPlayersLocalPersistenceContext);
}

export type useCustomPlayersLocalPersistenceReturn = {
  getTeamsWithSport: (sport: Sport) => Promise<Team[]>;
  getTeamWithId: (id: string) => Promise<Team>;
  createTeam: (team: Team) => Promise<void>;
  updateTeam: (id: string, team: Team) => Promise<void>;
  deleteTeam: (id: string) => Promise<void>;
};

export const CustomPlayersLocalPersistenceContext =
  createContext<LazyValue<useCustomPlayersLocalPersistenceReturn>>(undefined);
